import FiltersBar, { FiltersBarProps } from "./FiltersBar";

interface FiltersBarWithButtonProps extends FiltersBarProps {
  wrapperClassName: string;
  handleButtonClick: Function;
  buttonText: string;
}
export default function FiltersBarWithButton({
  wrapperClassName,
  handleButtonClick,
  buttonText,
  ...filtersBarProps
}: FiltersBarWithButtonProps) {
  return (
    <div className={wrapperClassName}>
      <FiltersBar {...filtersBarProps} />
      <div className="flex items-end justify-center">
        <button
          type="button"
          data-cy="filterCancel"
          onClick={() => handleButtonClick()}
          className="inline-flex items-center px-4 py-2 text-base font-medium rounded-md text-gray-700 bg-50 focus:outline-none"
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
}
